import clsx from 'clsx';
import React, { FC } from 'react';

import classes from './classes.module.css';

interface ResultProps {
  value: number;
  onClick: VoidFunction;
  isBad: boolean;
  isCorrect: boolean;
}

const Result: FC<ResultProps> = ({ value, onClick, isBad, isCorrect }) => {
  return (
    <div
      className={clsx(
        classes.container,
        isBad && classes.bad,
        isCorrect && classes.correct
      )}
      onClick={onClick}
    >
      {value}
    </div>
  );
};

export default Result;
